import {
  Button,
  ButtonElementTypes,
  ButtonSizeLG,
  ButtonSkinSecondary,
  ButtonSkinTertiary,
} from '@picsart/design-system/components/Button';

import { Badge, BadgeSizeMD, BadgeTypes } from '@picsart/design-system/components/Badge';
import addAnalyticsParamsToUrl from 'utils/addAnalyticsParamsToUrl';
import Image from 'components/Image';
import { FONTS_BUTTON_TEXT, LOAD_MORE_BUTTON, POST_LIMIT } from '../constants';
import NoResult from '../NoResult';
import FontListSkeleton from './FontListSkeleton/FontListSkeleton';
import { FontsListType } from '../types';
import useStyles from './styles';

const FontsList = ({ fontsData, chipTexts, fetchData, isLoading }: FontsListType) => {
  const styles = useStyles();

  if (isLoading) {
    return <FontListSkeleton landingsDataCount={fontsData?.data?.length} />;
  }

  return (
    <>
      {fontsData?.data && fontsData.data?.length > 0 ? (
        <div className={styles.fontsWrapper}>
          {fontsData?.data?.map((item, index) => {
            const keywords = item?.keywords
              ?.filter((keyword: string) => chipTexts.includes(keyword))
              .slice(0, 2);

            return (
              <div key={`${item.id}-${index}`} className={styles.item}>
                <div className={styles.itemHeaderWrapper}>
                  <Image
                    alt={item.meta_data.display_name}
                    className={styles.imageframe}
                    src={item.url ?? item.meta_data.font_svg_url}
                    height="100%"
                  />
                  <Button
                    skin={ButtonSkinSecondary}
                    className={styles.buttonStyle}
                    size={ButtonSizeLG}
                    tag={ButtonElementTypes.Link}
                    href={addAnalyticsParamsToUrl(`/create/editor?category=text&font=${item.id}`, {
                      source: 'use-this-font',
                      origin: 'fonts',
                    })}
                  >
                    {FONTS_BUTTON_TEXT}
                  </Button>
                </div>
                <p className={styles.itemFooterInfo}>
                  {item.is_paid && <Badge size={BadgeSizeMD} variant={BadgeTypes.Plus} />}
                  {keywords?.length > 0
                    ? keywords.map((keyword: string, itemIndex: number) => (
                        <span key={`${item.id}-keyword-${itemIndex}`}>
                          {keyword}
                          {keywords[itemIndex + 1] && itemIndex === 0 && (
                            <span className={styles.horizontalLine}>|</span>
                          )}
                        </span>
                      ))
                    : item?.meta_data?.font_name}
                </p>
              </div>
            );
          })}
          <div className={styles.loadMore}>
            {fontsData.landingsDataCount === POST_LIMIT && (
              <Button
                isFullWidth
                onClick={() => {
                  fetchData().catch(error => {
                    console.error('Error loading more:', error);
                  });
                }}
                skin={ButtonSkinTertiary}
                size={ButtonSizeLG}
              >
                {LOAD_MORE_BUTTON}
              </Button>
            )}
          </div>
        </div>
      ) : (
        <NoResult />
      )}
    </>
  );
};

export default FontsList;
